<!-- https://vuetifyjs.com/en/api/v-data-table/#api-props  -->
<!-- This is a data table with dynamically generated headers using props to change url -->
<template>
    <v-row justify-md="center" wrap>
        <MaterialfyColorCard :cardShowInnerText="false" :cardShowDivider="true" :cardShowActions="false"
            cardColor="secondary" cardMaxWidth="1000">
            <template v-slot:crdInner>
                <materialfy-header-card cardTitle='Bots' text="Here is a subtitle for this table" cardMinWidth="250"
                    :cardShowInnerList="false" :cardShowDivider="false" cardMaxWidth="1000">
                    <template v-slot:crdInner>
                        <v-data-table :headers="headers" :items="items" sort-by="id"
                            class="elevation-1 primary mx-auto" 
                            :mobile-breakpoint="0">
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" dark v-on="on"
                                            @click="handleClick(item, 'orders')">mdi-play</v-icon>
                                    </template>
                                    <span>Ordenes</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" dark v-on="on"
                                            @click="handleClick(item, 'update')">mdi-content-save-edit-outline</v-icon>
                                    </template>
                                    <span>Actualizar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" dark v-on="on"
                                            @click="handleClick(item, 'delete')">mdi-trash-can-outline</v-icon>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </template>
                    <template #crdActions>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                        <v-row no-gutters justify="center">
                            <v-btn @click="toHistoric">HISTORICO</v-btn>
                        </v-row>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                    </template>
                </materialfy-header-card>
            </template>
        </MaterialfyColorCard>
    </v-row>
</template>

<script>
import UserService from '@/services/user.service'
// import { genericApi } from "../../plugins/axios"

export default {
    props: {
        showHeader: {
            default: true
        },
        activateBreakpoint: {
            default: 0
        }
    },
    data: () => ({
        title: 'BOTS',
        // Variables
        // bot: new Bot("", "", "", ""),
        // Table
        headers: [
            { text: "Par", value: "bot.pair", align: "center" },
            { text: "Cantidad por Trade", value: "bot.quantity", align: "center" },
            { text: "Cantidad Bot", value: "bot.amount", align: "center" },
            { text: "En marcha", value: "bot.started", align: "center" },
            { text: "% Compra", value: "bot.buy", align: "center" },
            { text: "% Venta", value: "bot.sell", align: "center" },
            { text: 'Acciones', value: 'actions', sortable: false, align: "center" }
        ],
        items: [],
        search: '',
        // Shows
        isOpenDialog: false,
        content: "",
        message: "",
        successful: false
    }),

    computed: {},
    // called when page is created before dom to load data from api
    created() { },
    mounted() {
        this.prepareData()
    },

    methods: {
        prepareData() {
            UserService.getListBots().then(
                response => {
                    if (response.data !== '') {
                        this.items = response.data;
                    }
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    if (error.response && error.response.status === 403 || error.response.status === 401) {
                        this.$store
                            .dispatch('logout', this.user) //calls the login action and passes login info
                            .then(() => this.$router.push('/')) //redirect to dash after login
                            .catch((err) => {
                                console.log(err)
                                this.snackbar = true //shows error on wrong pass
                            })
                    }
                }
            );
        },
        handleClick(value, action) {
            switch (action) {
                case 'orders':
                    // this.$router.push('/orders/' + value.bot.id)
                    this.$router.push('/bots-orders/' + value.bot.id)
                    break;
                case 'update':
                    // console.log(value.bot)
                    if (!value.bot.automatico) {
                        this.$router.push('/bot_save/?idSuscripcion=' + value.id);
                    } else {
                        this.$router.push('/bot_auto_save/?idSuscripcion=' + value.id);
                    }

                    break;
                case 'delete':
                    this.bot = value.bot
                    this.openDialogQuestion()
                    break;
            }
        },
        openDialogQuestion() {
            this.$refs.dialogQuestions.openModal()
            this.$refs.dialogQuestions.component = 'DELETE_BOT'
            this.$refs.dialogQuestions.tituloDialog = 'Eliminar Bot'
            this.$refs.dialogQuestions.question = '¿ Desea realmente eliminar el bot ?'
        },
        eliminarBot() {
            UserService.deleteBot(this.bot).then(
                response => {
                    this.content = response
                    setTimeout(() => (this.responseDelete('success', this.content)), 2000)
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    setTimeout(() => (this.responseDelete('error', this.content)), 2000)
                }
            );
        },
        responseDelete(response, msg) {
            this.$refs.dialogMessages.openModal()
            this.$refs.dialogMessages.component = 'ELIMINAR BOT'
            this.$refs.dialogMessages.tituloDialog = 'ELIMINAR BOT'
            this.$refs.dialogMessages.msgError = msg
            this.$refs.dialogMessages.isShow = true
            if (response === 'success') {
                this.$refs.dialogMessages.types = 'success'
                this.successful = true
            } else {
                this.$refs.dialogMessages.types = 'error'
                this.successful = false
            }
        },
        closeAlert() {
            if (this.successful) {
                this.successful = false
                this.itemsTable = []
                this.prepareData()
            }
        },
        toHistoric() {
            this.$router.push('/bot_historic');
        }
    },
};
</script>

<style>
table.v-table thead tr {
    color: red !important;
}

tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>
